import BaseResource from './BaseResource';

export default class OrganizationSubscriptionResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  create() {
    return super
      .post({})
      .then((response) => response)
      .catch((error) => error.response);
  }

  get() {
    return super
      .get()
      .then((response) => response)
      .catch((error) => error.response);
  }

  customerPortal() {
    return super
      .get({ url: `${this.url}/customer_portal?redirect=manual` })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
